import React, { Fragment, useState } from 'react';
import cn from 'classnames';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import {
  ATTESTATION_PREFERENCE,
  ATTESTATION_SUBJECT,
} from 'legacy/src/constants/types';
import { Icon } from 'legacy-packages/ft-cb';
import { secureBrowserLink } from '../../generic/messages';
import { withSavePreference, withMeQuery } from 'legacy/src/components/util';
import { savePreferenceSuccess as savePreferenceSuccessAction } from 'legacy/src/components/auth/actions';
import {
  getPracticeExamUpdate,
  getAttestationUpdateJuly2020,
  getDefaultQBAttestationUpdate,
} from './copy';
import InfoMessage from 'chameleon/ui-stack/ui/basic/info-message';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

import './index.scss';

const AttestationDialog = ({
  me,
  subjectId,
  onSuccess,
  onRequestClose,
  onRequestDisagree = () => {},
  btnPrimary = 'I Agree',
  btnSecondary = 'I Do Not Agree',
  meQuery,
  savePreferenceSuccess,
  savePreference,
  onClose,
  showUpdatedAttestationDialog,
  showAttestationUpdateJuly2020,
}) => {
  const [disagreed, setDisagreed] = useState(false);
  const [isOpened, setOpen] = useState(true);
  const [showWarning, setWarning] = useState(false);

  let warningMessage =
    'In order to assign Practice Exams or Practice Exam questions, ' +
    'you will need to agree with the above security measures. Please confirm your selection.';

  const shieldIcon = <Icon name="secure" size="20px" />;
  let messageData;
  if (showAttestationUpdateJuly2020) {
    messageData = getAttestationUpdateJuly2020(shieldIcon);
    warningMessage = (
      <Fragment>
        Failure to follow this policy may result in termination of your access
        to AP resources.{' '}
        <span className="font-medium">Please confirm your selection</span>.
      </Fragment>
    );
  } else if (showUpdatedAttestationDialog) {
    messageData = getPracticeExamUpdate(secureBrowserLink);
  } else {
    messageData = getDefaultQBAttestationUpdate(secureBrowserLink);
  }

  const onAgree = () => {
    savePreference({
      variables: {
        userId: me.initId,
        preference: ATTESTATION_PREFERENCE,
        value: 'true',
        context: ATTESTATION_SUBJECT,
        contextId: subjectId,
      },
    }).then(() => {
      setOpen(false);
      meQuery.refetch().then(({ data }) => {
        savePreferenceSuccess(data.me);
      });
    });
  };

  const onDisagree = () => {
    if (disagreed) {
      setOpen(false);
      onRequestDisagree();
    } else {
      setDisagreed(true);
      setWarning(true);
    }
  };

  const messageBlocks = messageData.blocks || [];

  if (!isOpened) return null;

  return (
    <ConfirmDialog
      title={messageData.dialogTitle}
      size="big"
      content={{
        btnPrimary,
        btnSecondary,
        btnPrimaryType: showWarning ? 'success' : 'primary',
        btnSecondaryType: showWarning ? 'danger' : 'secundary',
      }}
      onSuccess={onSuccess || onAgree}
      onClose={onClose}
      onSecondaryBtnClick={onRequestClose || onDisagree}
      useRedGreenButtons={showWarning}
    >
      {showWarning && <InfoMessage isWarning>{warningMessage}</InfoMessage>}
      <div className="p-4.6">
        <div className="mb-4.6">
          {messageData.header && <div>{messageData.header}</div>}
          <div className="text-14 text-gray-700">{messageData.description}</div>
        </div>
        <div className="p-4.6 rounded-0.4 bg-gray-100 border border-gray-300">
          {messageBlocks.map((blockMessage, index) => (
            <div
              key={`block-${String(index)}`}
              className={cn('text-14 leading-8', {
                'mb-4.6': index < messageBlocks.length - 1,
              })}
            >
              {blockMessage}
            </div>
          ))}
        </div>
      </div>
    </ConfirmDialog>
  );
};

export default compose(
  connect(
    ({
      userData: { me },
      featureFlag: {
        show_updated_attestation_dialog,
        attestation_update_july_2020,
      },
    }) => ({
      me,
      showUpdatedAttestationDialog: show_updated_attestation_dialog,
      showAttestationUpdateJuly2020: attestation_update_july_2020,
    }),
    { savePreferenceSuccess: savePreferenceSuccessAction },
  ),
  withSavePreference,
  withMeQuery,
)(AttestationDialog);
